import React from 'react'
import ReactDOM from 'react-dom'
import App from './app/App'
import * as serviceWork from './serviceWorker'

ReactDOM.render(
  <App />,
  document.getElementById('root'),
)

serviceWork.register()
